export default __webpack_public_path__ + "static/media/video-outline.81a84afa.svg";